// @flow
export const saveStates = {
    DEFAULT: 'DEFAULT',
    SAVING: 'SAVING',
    SAVED: 'SAVED',
    SAVED_END: 'SAVED_END',
    SAVE_ERROR: 'SAVE_ERROR',
    SAVE_ERROR_END: 'SAVE_ERROR_END'
};
export type SaveState = $Keys<typeof saveStates>;

// the value represent a key of the primaryBtnColors from the theme file ( when the theme and styled components
// will be fully typed then we can define proper enumeration for the primary button colours)
const colorMapKey: { [SaveState]: string } = {
    [saveStates.DEFAULT]: 'default',
    [saveStates.SAVING]: 'busy',
    [saveStates.SAVED]: 'default',
    [saveStates.SAVED_END]: 'default',
    [saveStates.SAVE_ERROR]: 'error',
    [saveStates.SAVE_ERROR_END]: 'error'
};

export const getBgColorKey = (saveState: SaveState) => colorMapKey[saveState];



// WEBPACK FOOTER //
// ./src/core/constants/components/widgets/buttons/async/index.js